import APIs from '../../apiUrl';

const getAllCustomer = async (payload) => {
  try {
    const response = await APIs.get(
      `/get_all_users/${payload?.page}/${payload?.limit}`
    );

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getSingleCustomer = async (payload) => {
  try {
    const response = await APIs.get(`/get_single_users/${payload?.id}`);

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getTotalUserCount = async () => {
  try {
    const response = await APIs.get(`/get_total_users`);

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getSearchCustomer = async (payload) => {
  try {
    const response = await APIs.get(
      `/user_search_for_user/${payload?.name}/${payload?.page}/${payload?.limit}`
    );

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const CustomerServices = {
  getAllCustomer,
  getSingleCustomer,
  getTotalUserCount,
  getSearchCustomer,
};

export default CustomerServices;
